<template>
  <!-- 10-4 用户医疗机构求人案件自身信息列表 -->
  <div class="main-css">
    <!--    标题-->
    <div class="title-css">{{$t("jobOffer")}}</div>
    <div class="main-box">
      <!-- button 部分 -->
      <div class="line-button-box">
        <el-button class="button-css" @click="handleAddClick">{{$t("new")}}</el-button>
        <el-dropdown @command="handleUserUpdateJobStatus">
          <el-button type="primary" class="button-css" >
            {{$t("changeState")}}
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="(item1,index) in showStatusData"
              :key="item1.code"
              :command="item1"
            >{{item1.name}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
<!--        <el-button class="button-css" @click="handleDeleteJobInfo">{{$t("delete")}}</el-button>-->
      </div>
      <!-- table部分 -->
      <div class="table">
        <el-table
          @row-click="jump2"
          :data="tableData"
          style="width: 95%"
          height="425"
          @sort-change="changeTableSort"
          @selection-change="handleSelectionChange"
          v-loading="loading"
        >
          <el-table-column type="selection" width="45"> </el-table-column>
          <!-- ----------------------案件番号---------------------- -->
          <el-table-column prop="jobId" label="案件番号" width="150" header-align="center" :show-overflow-tooltip="true">
            <template slot="header" slot-scope="scope">
              <p>{{ $t("caseNumber") }}</p>
                <el-input
                  v-model="searchData1"
                  size="mini"
                  placeholder="Search"
                  @input="changeFuzzySelectJobInfo"
                  clearable
                />
            </template>
            <template slot-scope="scope">
              <span >{{scope.row.jobId}}</span>
            </template>
          </el-table-column>
          <!-- ----------------------案件名---------------------- -->
          <el-table-column prop="jobName" label="案件名" width="280" header-align="center" :show-overflow-tooltip="true">
            <template slot="header" slot-scope="scope">
              <p>{{ $t("caseName") }}</p>
              <el-input
                v-model="searchData2"
                size="mini"
                placeholder="Search"
                @input="changeFuzzySelectJobInfo"
                clearable
              />
            </template>
            <template slot-scope="scope">
              <span @click="jump(scope.row.jobId,scope.row.reviewStatus)"> {{scope.row.jobName}}</span>
            </template>
          </el-table-column>
          <!-- ---------------------勤務地-------------------- -->
          <el-table-column prop="workSpace" label="勤務地" header-align="center" :show-overflow-tooltip="true">
            <template slot="header" slot-scope="scope">
              <p>{{ $t("workLocation") }}</p>
              <el-input
                v-model="searchData3"
                size="mini"
                placeholder="Search"
                @input="changeFuzzySelectJobInfo"
                clearable
              />
            </template>
            <template slot-scope="scope">
              {{scope.row.workSpace}}
            </template>
          </el-table-column>

          <!-- ----------------------掲載日---------------------- -->
          <el-table-column prop="createTime" width="200" label="掲載日" header-align="center" :show-overflow-tooltip="true">
            <template slot="header" slot-scope="scope">
              <p>{{ $t("payonTheDay") }}</p>
              <el-date-picker
                v-model="searchData4"
                type="datetime"
                @blur="dataTimeChange"
                @change="pickerChangeFn"
                format="yyyy-MM-dd HH-mm-ss"
                :placeholder="$t('registerDayselsect')">
              </el-date-picker>
            </template>
            <template slot-scope="scope">
            {{scope.row.createTime}}
          </template>
          </el-table-column>
          <!-- ----------------------担当者---------------------- -->
          <el-table-column prop="name" label="担当者" header-align="center" :show-overflow-tooltip="true">
            <template slot="header" slot-scope="scope">
              <p>{{ $t("inauguration") }}</p>
              <el-input
                v-model="searchData5"
                size="mini"
                placeholder="Search"
                @input="changeFuzzySelectJobInfo"
                clearable
              />
            </template>
            <template slot-scope="scope">
             {{scope.row.name}}
            </template>

          </el-table-column>

          <!-- -----------------------観覧回数----------------------- -->
          <el-table-column
            prop="visitedTime"
            label="観覧回数"
            sortable
            width="130"
            :show-overflow-tooltip="true"
          >
            <template slot="header">
              <p class="operate">      {{ $t("numberOfVisits") }}</p>

            </template>
            <template slot-scope="scope">
              {{ scope.row.visitedTime }}
            </template>
          </el-table-column>
          <!-- ------------------------応募者------------------------ -->

          <el-table-column
            prop="recruitNumber"
            label="応募者"
            sortable
            width="130"
            :show-overflow-tooltip="true"
          >
            <template slot="header">
              <p class="operate">{{ $t("candidates") }}</p>
            </template>
            <template slot-scope="scope">
             {{ scope.row.recruitNumber }}
            </template>
          </el-table-column>

          <!-- ------------------------状態------------------------ -->

          <el-table-column
            label="状態"
            sortable
            width="130"
            :show-overflow-tooltip="true"
          >
            <template slot="header">
              <p class="operate">{{ $t("status") }}</p>
            </template>
            <template slot-scope="scope">
              <span v-if="language === 'CN'">
                {{ scope.row.reviewStatus_dictText }}
              </span>
              <span v-else>
                {{ scope.row.jpreviewStatus_dictText }}
              </span>
            </template>
          </el-table-column>
          <!-- ----------------------推進---------------------- -->
          <el-table-column prop="contractNumber,applyNumber" label="推進" header-align="center" :show-overflow-tooltip="true">
            <template slot="header" slot-scope="scope">
              <p class="operate">{{ $t("advance") }}</p>
            </template>
            <template slot-scope="scope">
              {{scope.row.contractNumber}}/{{scope.row.applyNumber}}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页部分 -->
      <div class="pagination">
        <div class="pagination-main">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            layout=" prev, pager, next"
            :total="total"
            :page-size="pageSize"
          >
          </el-pagination>
          <!-- Rows per page -->
          <div class="rowsPage">
            <span>Rows per page</span>
            <div class="rowsPage-css">
              <el-dropdown @command="handleCommand">
                <span class="el-dropdown-link">
                  {{pageSize}}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="a">7</el-dropdown-item>
                  <el-dropdown-item command="b">15</el-dropdown-item>
                  <el-dropdown-item command="c">20</el-dropdown-item>
                  <el-dropdown-item command="d">25</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  fuzzySelectJobInfo,
  medicalJobInfoDeleteJobInfo,
  selectJobInfo,
  selectMyJobInfo,
  userUpdateJobStatus
} from "../../js/api";
  import AES from "../../js/AES";
import axios from "axios";

  export default {
    name: "userInformationListOfMedicalInstitutionsSeekingApplicants",
    components: {},
    data() {
      return {
        total:0,
        tableData: [],
        searchData1: "", //表格第一个搜索  岗位id
        searchData2: "", //表格第二个搜索  事件名
        searchData3: "", //表格第三个搜索  工作地
        searchData4: "", //表格第四个搜索  目标录用时间
        searchData5:"",  //表格第五个搜索  姓名
        searchData6:"",  //表格第六个搜索 进度
        currentPage: 1, //页数
        pageSize: 7, //每页条数
        loading: false, //table loading
        searchDataStart: "",
        jobId:"",
        reviewStatus:"",
        jobIdList:[],
        statusData:[],
        totalNum: 0,
        showStatusData:[],
        language:"",
        principal:"All",
        medicalStatusChange:"",
      };
    },
    created() {
      //获取当前语言的值
      this.language = window.localStorage.getItem('language');
      console.log(this.language,"语言")
      this.getLanguage();
      this.searchDataStart = this.$route.query.searchData;
      console.log(this.searchDataStart);
      this.getSelectMyJobInfo();
      this.getShowReviewStatus();
    },
    computed: {},
    methods: {
      //获得语言
      getLanguage() {
        if(this.language==="CN")
        {
          this.medicalStatusChange="medicalStatusChange"
        }
        else
        {
          this.medicalStatusChange="jpmedicalStatusChange"
        }
      },
      //table排序
      changeTableSort(column){
        console.log(column);
        if (column.prop === "solicitor") {
          if (column.order === "ascending") {
            this.tableData = this.tableData.sort(
              (a, b) => a["solicitor"] - b["solicitor"]
            );
          } else {
            this.tableData = this.tableData.sort(
              (a, b) => b["solicitor"] - a["solicitor"]
            );
          }
        } else {
          if (column.order === "ascending") {
            this.tableData = this.tableData.sort(
              (a, b) => a["returnNumber"] - b["returnNumber"]
            );
          } else {
            this.tableData = this.tableData.sort(
              (a, b) => b["returnNumber"] - a["returnNumber"]
            );
          }
        }
      },
      //页码变化
      handleCurrentChange(evt) {
        this.currentPage=evt
        console.log(this.currentPage);
        this.getSelectMyJobInfo();
      },
      //每页条数下拉框
      handleCommand(command) {
        if (command === "a") {
          this.pageSize = 7;
          console.log(this.pageSize);
        } else if (command === "b") {
          this.pageSize = 15;
          console.log(this.pageSize);
        } else if (command === "c") {
          this.pageSize = 20;
          console.log(this.pageSize);
        } else if (command === "d") {
          this.pageSize = 25;
          console.log(this.pageSize);
        }
        this.getSelectMyJobInfo();
      },
      dataTimeChange() {
        this.principalTime = this.timeJs(this.searchData4)
        this.changeFuzzySelectJobInfo();
      },
      timeJs(date) {
        //获取年份
        var y = date.getFullYear();
        //获取月份  返回0-11
        var m = date.getMonth() + 1;
        // 获取日
        var d = date.getDate();
        //获取星期几  返回0-6   (0=星期天)
        var w = date.getDay();
        //星期几
        var ww = ' 星期' + '日一二三四五六'.charAt(date.getDay());
        //时
        var h = date.getHours();
        //分
        var minute = date.getMinutes()
        //秒
        var s = date.getSeconds();
        //毫秒
        var sss = date.getMilliseconds();

        if (m < 10) {
          m = "0" + m;
        }
        if (d < 10) {
          d = "0" + d;
        }
        if (h < 10) {
          h = "0" + h;
        }
        if (minute < 10) {
          minute = "0" + minute;
        }
        if (s < 10) {
          s = "0" + s;
        }
        if (sss < 10) {
          sss = "00" + sss;
        } else if (sss < 100) {
          sss = "0" + sss;
        }
        return y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + s;
      },
      pickerChangeFn(value){
        if(value===null){
          this.principalTime = ""
          this.changeFuzzySelectJobInfo();
        }
      },
      //点击案件名，根据状态跳转 0:7-2 其他10-3
      jump(jobId,reviewStatus){
        if(reviewStatus==='0'){
          this.$router.push({
            path:'/medicalInstitutionJobCreationOne',
            name:'medicalInstitutionJobCreation',
            query:{ jobId: jobId}
          });
        }else{
          this.$router.push({
            path:'/medicalInstitutionCaseManagementDetails',
            name: 'medicalInstitutionCaseManagementDetails',
            query:{ jobId: jobId}
          });
        }
      },
      //点击行 跳转至11-1  传jobId
      jump2(row) {

        if(row.reviewStatus == '0'){
           this.$router.push({
            path:'/medicalInstitutionJobCreationOne',
            name:'medicalInstitutionJobCreation',
            query:{  jobId:row.jobId}
          });
        }else{
this.$router.push({
          path: '/medicalInstitutionCaseRecruitmentList',
          name: 'medicalInstitutionCaseRecruitmentList',
          query:{
            jobId:row.jobId}
        });
        }

      },
      handleSelectionChange(val) {
        this.multipleSelection=val
        this.jobIdList = []
        this.jobId=[]
        this.reviewStatus=[]
        console.log(val)
        for (var i = 0; i < val.length; i++) {
          this.jobIdList.push(val[i].jobId)
          this.jobId=val[0].jobId
          this.reviewStatus=val[0].reviewStatus
        }
      },
      //button
      handleAddClick(){
        console.log("＋新たなbutton");
        this.$router.push({
          path:'/medicalInstitutionJobCreationOne',
          name:'medicalInstitutionJobCreation',
        });
      },



      //接口
      //医疗机构普通账户查看自身发布的岗位信息接口
      getSelectMyJobInfo(){
        var pageDTO={
          pageNumber: this.currentPage,
          pageSize: this.pageSize
        }
        selectMyJobInfo(pageDTO).then((res)=>{
          console.log("--------医疗机构普通账户查看自身发布的岗位信息接口数据--------");
          console.log(res);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data))
            console.log(aesFecInfo)
            this.tableData = aesFecInfo.data
            this.total=aesFecInfo.total;
          }else if (res.data.code ===10001) {

       // this.$message.error("查询成功");
       window.location.href="#/userFailure";
     }
        }).catch((res)=>{
          console.log("医疗机构普通账户查看自身发布的岗位信息接口数据异常:",res)
        })

      },
      //医疗机构求人案件删除接口
      handleDeleteJobInfo(){
        var jobListIdDTO={
          listId: this.jobIdList
        }
        medicalJobInfoDeleteJobInfo(jobListIdDTO).then((res)=>{
          console.log("--------医疗机构求人案件删除接口数据--------");
          console.log(res);
          if (res.data.code === "A0000") {
            this.$router.go(0)
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data))
            console.log(aesFecInfo)
            this.tableData = aesFecInfo.data
          }
        }).catch((res)=>{
          console.log("医疗机构求人案件删除接口数据异常:",res)
        })

      },

      //医疗机构管理查看求人信息模糊查询接口
      changeFuzzySelectJobInfo(){
        var medicalFuzzySelectJobInfoDTO={
          jobId:this.searchData1,
          jobName: this.searchData2,
          name: this.searchData5,
          pageNumber: this.currentPage,
          pageSize:this.pageSize,
          principalTime: this.searchData4,
          workSpace: this.searchData3,
        }
        fuzzySelectJobInfo(medicalFuzzySelectJobInfoDTO).then((res)=>{
          console.log("--------医疗机构管理查看求人信息模糊查询接口数据--------");
          console.log(res);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data))
            console.log(aesFecInfo)
            this.tableData = aesFecInfo.data
          }
        }).catch((res)=>{
          console.log("医疗机构管理查看求人信息模糊查询接口数据异常:",res)
        })

      },

      //用户变更案件状态接口
      handleUserUpdateJobStatus(evt){
        if(this.multipleSelection.length === 0){
          this.$message({
            showClose: true,
            message: '请选择一名用户',
            type: 'warning'
          });
        }else if(this.multipleSelection.length > 1){
          this.$message({
            showClose: true,
            message: '最多只能选择一名用户',
            type: 'warning'
          });
        }else {
          var medicalUpdateJobStatusDTO = {
            jobId: this.jobId,
            reviewStatus: evt.code
          }
          userUpdateJobStatus(medicalUpdateJobStatusDTO).then((res) => {
            console.log("--------用户变更案件状态接口数据--------");
            console.log(res);
            if (res.data.code === "A0000") {
              this.$router.go(0)
              const aesFecInfo = JSON.parse(AES.decrypt(res.data.data))
              console.log(aesFecInfo)
              this.$message({
                message: aesFecInfo.message,
              });
            }
          }).catch((res) => {
            console.log("用户变更案件状态接口数据异常:", res)
          })
        }
      },
      getShowReviewStatus(){
        var that=this;
        that.getLanguage();

        axios.get('/api/modules-parent/common/getDateItem',
          {
            params: {
              dataItem:that.medicalStatusChange
            },
            headers:{
              'content-type': 'application/x-www-form-urlencoded',
              "token":localStorage.getItem("token")
            }
          })
          .then(function (res) {
            if(res.data.code === "A0000"||res.data.code === "C0252"){
              console.log("--------获取数据字典接口数据caseStatusShow--------");
              console.log(res);
              const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
              that.showStatusData=aesFecInfo.data;
              console.log("--------获当然是看获取的状态了--------");

              console.log(that.showStatusData);
            }else{
              console.log(res.data);
              that.$message.error(res.data.message);
            }
          })
          .catch((res) => {
            console.log(res);
          });
      },

    },
  };
</script>
<style scoped>
  .main-css {
    width: 100%;
    height: 100%;
    position: relative;
  }
  .main-box {
    margin-top: 0px;
    width: 100%;
    padding: 0 40px 0 80px;
    box-sizing: border-box;
  }
  .title-css {/*标题样式*/
    font-family: "lucida sans unicode", "lucida grande", sans-serif; /*字体*/
    color: #686868; /*字体颜色*/
    font-size: 2em; /*字体大小*/
    text-align: center; /*对齐方式*/
    line-height: 76px; /*行间距*/
    margin-top: 10px;
  }
  .line-button-box {
    height: 40px;
    width: 100%;
    display: flex;
    margin-top: 25px;
    margin-left: 40px;
  }
  .button-css {
    width: 90px;
    height: 35px;
    background: #51abff;
    box-sizing: border-box;
    border-radius: 4px;
    font-weight: 500;
    font-size: 12px;
    color: #fff;
    margin-right: 25px;
    text-align: center;
  }
  .search {
    width: 100%;
    height: 25px;
    display: flex;
  }
  .search /deep/ .el-input__inner {
    width: 314px;
    height: 24px;
  }
  .search /deep/ .el-input {
    width: 314px;
    height: 24px;
    line-height: 24px;
    box-sizing: border-box;
  }
  .search /deep/ .el-input__icon {
    line-height: 24px;
  }
  .search button {
    width: 85px;
    height: 24px;
    line-height: 24px;
    background: #fafafa;
    border: 1px solid #51abff;
    box-sizing: border-box;
    border-radius: 8px;
    font-family: "Inter";
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    color: #51abff;
    cursor: pointer;
    margin-left: 20px;
  }
  .table {
    width: 100%;
    margin-top: 20px;
    height: 430px;
  }
  .table /deep/ .el-input__inner {
    border: 1px solid transparent;
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.25px;
    color: #c9cfda;
    padding: 0;
    text-align: center;
  }
  .operate {
    height: 51px;
  }
  .table /deep/ .el-dropdown {
    width: 60px;
  }
  .table-img-css {
    border-radius:50%;
  }
  .el-dropdown-link {
    cursor: pointer;
    font-family: "Open Sans";
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.25px;
    color: #909399;
    width: 100%;
    display: inline-block;
  }
  .table /deep/ .el-icon-arrow-down {
    float: right;
    height: 20px;
    line-height: 20px;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
  .table /deep/ .el-table__cell {
    position: relative;
    text-align: center;
  }
  .table /deep/ .caret-wrapper {
    display: inline-block;
    position: absolute;
    top: -4px;
    right: -48px;
    width: 67px;
  }
  .pagination {
    width: 95%;
    height: 50px;
    margin-top: 10px;
  }
  .pagination-main {
    float: right;
    margin-right: 10px;
    display: flex;
  }
  .rowsPage {
    height: 30px;
    line-height: 30px;
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    letter-spacing: 0.25px;
    color: #454d59;
    display: flex;
    margin-left: 10px;
  }
  .rowsPage-css {
    width: 60px;
    height: 26px;
    line-height: 26px;
    background: #ffffff;
    border: 1px solid #b0bac9;
    box-sizing: border-box;
    padding: 0 5px 0 10px;
    margin-left: 12px;
  }
  .rowsPage /deep/ .el-dropdown-link {
    width: 45px;
    height: 26px;
    line-height: 26px;
  }
  .rowsPage /deep/ .el-icon-arrow-down {
    float: right;
    line-height: 26px;
  }
</style>




// WEBPACK FOOTER //
// src/pages/userInformationListOfMedicalInstitutionsSeekingApplicants/index.vue